import { Box, Typography, Button, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import gorillaLogo from "../imagenes/Gorillameditando.png";

export default function Forbidden() {
  const buttonStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.5rem 1.5rem",
    borderRadius: "13rem",
    border: "1px solid transparent",
    fontSize: "0.875rem",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: "#1e9e85",
    color: "#fff",
    textTransform: "none",
    whiteSpace: "nowrap",
    minWidth: "120px",
    maxWidth: "100%",
    "&:hover": {
      opacity: 0.85,
      backgroundColor: "#1e9e85",
    },
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        boxSizing: "border-box",
        padding: { xs: 2, sm: 3 },
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          width: "90vw", // ancho relativo al viewport
          maxWidth: 900, // máximo 900px
          maxHeight: "90vh", // máximo 90% alto de pantalla
          overflowY: "auto",
          backgroundColor: "#fff",
          border: "4px inset #000",
          borderRadius: "12px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          textAlign: "center",
          boxSizing: "border-box",
          padding: { xs: 2, sm: 4 },
          margin: "auto",

          // Mejoras en pantallas pequeñas y orientación vertical:
          "@media (max-width:600px), (orientation: portrait)": {
            width: "95vw", // casi todo el ancho disponible
            maxWidth: "95vw", // no superar ese ancho
            maxHeight: "85vh", // un poco menos de alto para evitar scroll
            padding: 2,
          },
        }}
      >
        {/* Imagen: aquí la hacemos más grande en pantallas estrechas */}
        <Box
          component="img"
          src={gorillaLogo}
          alt="Gorilla"
          sx={{
            height: { xs: 180, sm: 150, md: 260 }, // +grande en xs (pantallas muy pequeñas)
            maxWidth: "100%",
            objectFit: "contain",
            mb: { xs: 1, sm: 2 },
            "@media (max-height:600px) and (min-width:800px)": {
              height: 115, // imagen más pequeña para Nest Hub
              mb: 0.5,
            },
          }}
        />

        {/* Título */}
        <Typography
          variant="h2"
          fontWeight="bold"
          sx={{
            fontSize: { xs: "1.5rem", sm: "2.5rem", md: "3rem" },
            mb: { xs: 1, sm: 2 },
          }}
        >
          ERROR 404
        </Typography>

        {/* Divider */}
        <Divider
          sx={{
            width: 100,
            height: 4,
            backgroundColor: "#1e9e85",
            mb: { xs: 2, sm: 3 },
            mx: "auto",
          }}
        />

        {/* Texto */}
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            fontSize: { xs: "0.85rem", sm: "1rem" },
            maxWidth: "600px",
            mx: "auto",
            mb: { xs: 2, sm: 4 },
            lineHeight: 1.3,
            "@media (max-height:600px) and (min-width:800px)": {
              fontSize: "1.1rem",
            },
          }}
        >
          Has seguido el camino del mono, pero este sendero no lleva a ninguna parte. No tienes
          autorización para ver esta pantalla. Tómalo con calma, vuelve al inicio y sigue
          explorando; si el problema persiste, nuestro equipo estará encantado de ayudarte.
        </Typography>

        {/* Botones */}
        <Box display="flex" justifyContent="center" flexWrap="wrap" gap={1} width="100%" mb={2}>
          {" "}
          <Button component={Link} to="/" sx={buttonStyle}>
            Volver al inicio
          </Button>
          <Button
            component={Link}
            to="/"
            sx={{
              ...buttonStyle,
              backgroundColor: "#000",
              "&:hover": { backgroundColor: "#333" },
            }}
          >
            Contacto
          </Button>
        </Box>

        {/* Zona de práctica */}
        <Box width="100%">
          <section className="playground">
            <div className="card">{/* contenido adicional */}</div>
          </section>
        </Box>
      </Box>
    </Box>
  );
}
